import { useState } from "react";

interface CheckBoxProps {
	items: { label: string; value: string }[];
	onChange: (selectedValues: string[]) => void;
	size?: "sm" | "md" | "lg";
	className?: string;
	checkBoxMode?: "single" | "multiple";
	initialValue?: string[];
}

export const CheckBox: React.FC<CheckBoxProps> = ({ className, items, onChange, checkBoxMode = "single", size = "md", initialValue }) => {
	const [selectedValues, setSelectedValues] = useState<string[]>(initialValue || []);

	const sizeText = {
		sm: "text-xs md:text-sm",
		md: "text-sm md:text-base",
		lg: "text-base md:text-lg",
	};

	const handleCheckboxChange = (value: string) => {
		let newSelectedValues: string[];

		if (checkBoxMode === "single") {
			newSelectedValues = selectedValues.includes(value) ? [] : [value];
		} else {
			newSelectedValues = selectedValues.includes(value) ? selectedValues.filter((item) => item !== value) : [...selectedValues, value];
		}

		setSelectedValues(newSelectedValues);
		onChange(newSelectedValues);
	};

	return (
		<>
			{items.map((item) => (
				<div
					key={item.value}
					className="flex items-center gap-2"
				>
					<label
						className={`${sizeText[size]} ${className} peer flex flex-row items-center gap-2.5`}
						htmlFor={item.value}
					>
						{item.label}
						<input
							type="checkbox"
							id={item.value}
							value={item.value}
							checked={selectedValues.includes(item.value)}
							onChange={() => handleCheckboxChange(item.value)}
							className="peer hidden"
							disabled={checkBoxMode === "single" && selectedValues.length > 0 && !selectedValues.includes(item.value)}
						/>
						<div className="h-5 w-5 flex rounded-[4px] border border-orange-200 bg-orange-100 peer-checked:bg-orange-500 transition">
							<svg
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								className="w-5 h-5 stroke-orange-100"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M4 12.6111L8.92308 17.5L20 6.5"
									strokeWidth="4"
									strokeLinecap="round"
									strokeLinejoin="round"
								></path>
							</svg>
						</div>
					</label>
				</div>
			))}
		</>
	);
};
